import React from 'react';
import Button from './Button';

interface AlertPropsBase {
  onDismiss?: () => void;
}

type AlertProps = AlertPropsBase & React.HTMLAttributes<HTMLDivElement>;

export default function Alert(props: AlertProps) {
  const { className: propClasses, children, onDismiss, ...rest } = props;

  const classes = ['px-3 py-2 rounded bg-emphasis text-white flex items-start gap-2'];
  if (propClasses) classes.push(propClasses);

  return (
    <div {...rest} className={classes.join(' ')}>
      <span className="flex-grow">{children}</span>
      {onDismiss && (
        <Button
          variant="white"
          inverse
          onClick={onDismiss}
          icon={['fass', 'xmark']}
          className="border-none-i p-1-i"
        />
      )}
    </div>
  );
}
